import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

/**
 * Hook to check if the current user has access to the UCP
 * This checks the user's email against the hardcoded authorized list
 */
export const useUcpAccess = () => {
  const { isAuthenticated, user } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const checkUcpAccess = async () => {
      if (!isAuthenticated || !user) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError('');
        
        // Try to access UCP dashboard endpoint to check access
        const token = localStorage.getItem('token');
        const config = { headers: { Authorization: `Bearer ${token}` } };
        const response = await axios.get('/api/ucp/dashboard', config);
        setHasAccess(true);
      } catch (err: any) {
        if (err.response?.status === 403) {
          // Access denied - user doesn't have UCP access
          setHasAccess(false);
        } else {
          // Other error - log it but don't show to user
          console.error('Error checking UCP access:', err);
          setError('Failed to check UCP access');
          setHasAccess(false);
        }
      } finally {
        setLoading(false);
      }
    };

    checkUcpAccess();
  }, [isAuthenticated, user]);

  return {
    hasAccess,
    loading,
    error
  };
};
